import { getter } from '../../common';

export default function getField(field, row) {
    if (row === null) {
        return row;
    }

    var get = getter(field, true);
    return get(row);
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@progress/kendo-charts/dist/es/chart/utils/get-field.js
// module id = 630
// module chunks = 29